// extracted by css-extract-rspack-plugin
export default {"threadReplyComposer":"ExpandedThread-module__threadReplyComposer__WH0eX","threadReplySpacer":"ExpandedThread-module__threadReplySpacer__KxfNI"};